import {Button, Modal} from 'antd';
import React, {useCallback, useMemo, useState} from 'react';
import {CustomerDetailsCard} from './CustomerDetails';
import {customerModelData} from '../../services/ModelService';
import {Customer} from '../../model/customer';
import {Form} from 'antd';

export default function CustomerDetailsModal({visible, closeDisplay, onNewCustomer}) {
    const [form] = Form.useForm();
    const mode = useMemo(() => ({edit: true}), []);
    const [customer, setCustomer] = useState(new Customer({customerId: '_'}));
    const [isLoading, setIsLoading] = useState(false);
    const [hasSubmitted, setHasSubmitted] = useState(false);

    const setCustomerWith = useCallback(
        (propName, value) => {
            if (!Array.isArray(propName)) {
                propName = [propName];
                value = [value];
            }
            setCustomer(customer => {
                const newCustomer = {...customer};
                propName.forEach((prop, idx) => {
                    if (value[idx] === undefined || value[idx] === null) {
                        delete newCustomer[prop];
                        return;
                    }
                    newCustomer[prop] = value[idx];
                });
                return newCustomer;
            });
        },
        [setCustomer]
    );

    const handleSubmit = async () => {
        setHasSubmitted(true);
        try {
            await form.validateFields();
            setIsLoading(true);
            await customerModelData.save(customer);
            console.log('customer saved');
            onNewCustomer(customer);
            setIsLoading(false);
        } catch (error) {
            // Form validation errors will be shown automatically by Ant Design
            console.error('Validation failed:', error);
        }
    };

    const handleValuesChange = () => {
        // Clear validation errors for fields that have been changed
        form.validateFields().catch(() => {});
    };

    return (
        <Modal
            open={visible}
            title={`New customer`}
            onCancel={closeDisplay}
            destroyOnClose
            centered
            width={800}
            className='customer-details-modal'
            footer={[
                <Button className="btn-secondary" key="back" onClick={closeDisplay}>
                    Cancel
                </Button>,
                <Button className="btn-primary" key="submit" type="primary" loading={isLoading} onClick={handleSubmit}>
                    Submit
                </Button>,
            ]}
        >
            <Form 
                form={form} 
                layout="vertical" 
                validateTrigger={hasSubmitted ? 'onChange' : 'onSubmit'}
                onValuesChange={handleValuesChange}
            >
                <CustomerDetailsCard mode={mode} customer={customer} setCustomerWith={setCustomerWith} form={form}/>
            </Form>
        </Modal>
    );
}